export default {"src":"/login-app/[GIT_HASH]/_next/static/media/check_failed.2124ea2b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};